import debug from 'bows';
import Microsite from '../_microsite';
import fitvid from '../_fitvid';

const log = debug('ai');

class MicrositeAi extends Microsite {
	constructor(url) {
		this.headerShown = false;
		this.parallaxSpeed;
		this.parallaxPanels = [];
		this.panelLogos = [];

		super(url);
	}

	init() {
		super.init();

		// YouTube API ready promise
		this.ytAPIReadyPromise = new Promise((resolve, reject) => {
			// Attach YouTube API Ready
			window.onYouTubeIframeAPIReady = () => {
				log('YouTube API Ready');
				resolve();
			};

			// Timeout after 60 seconds
			setTimeout(() => reject(), 60000);
		});
		this.ytAPIInit();
		this.videoInit();

		this.sectorMenuInit();

		window.addEventListener('header.show', () => {
			this.headerShown = true;
		});
		window.addEventListener('header.hide', () => {
			this.headerShown = false;
		});
	}

	scrollTo(location, animate) {
		log('scrollTo', location);

		// Measure before scrolling
		this.measure();

		let scrollTop;
		let section;
		if (typeof location === 'number') {
			scrollTop = location;
		} else if (typeof location === 'string') {
			// Find section
			section = this.find(location);
			if (!section) {
				return false;
			}
			scrollTop = section.top;
		} else {
			// Unknown location
			return false;
		}

		// Set scrolling flag
		this.scrolling = true;
		this.header.disableEvents();

		// Scroll to
		if (animate) {
			if (section) {
				let number = section.$.data('number');
				let $splash = $('.microsite-ai__splash');

				$splash
					.text(number)
					.fadeIn(250, () => {
						window.scrollTo(0, scrollTop);
						this.scrolling = 'reset';
						this.header.resetTop();
						this.header.enableEvents();
					})
					.delay(500)
					.fadeOut(250, () => {

					});
			} else {
				$('html, body').animate({
					scrollTop: scrollTop
				}, 250, 'swing', () => {
					this.scrolling = 'reset';
					this.header.resetTop();
					this.header.enableEvents();
				});
			}
		} else {
			window.scrollTo(0, scrollTop);
			this.scrolling = 'reset';
			this.header.resetTop();
			this.header.enableEvents();
		}
	}

	measure() {
		//Panel Logos Positioning(must be first as it affect section height)
		this.panelLogos = [];
		$('.ai-panel__logos').each((index, logos) => {
			let $logos = $(logos);
			let $children = $logos.children();
			let top = Math.floor($logos.offset().top);
			let height = Math.floor($logos.height());
			let bottom = top + height;

			this.panelLogos.push({
				$: $logos,
				top: top,
				bottom: bottom,
				height: height
			});

			// 	// Total height for redistributing columns
			// 	let totalHeight = 0;
			// 	$children.each((index, logo) => {
			// 		totalHeight += $(logo).outerHeight(true);
			// 	});

			// 	if (window.matchMedia('(min-width: 700px)').matches) {
			// 		// Medium up (5 col)
			// 		$logos.css('height', totalHeight / 5);

			// 		// Offset second col
			// 		let fifth = Math.floor($children.length / 5);
			// 		$children.each((index, logo) => {
			// 			if (index >= fifth && index < fifth * 2) {
			// 				$(logo).addClass('ai-panel__logos-logo--up');
			// 			} else if (index >= fifth * 3 && index < fifth * 4) {
			// 				$(logo).addClass('ai-panel__logos-logo--up');
			// 			} else if (index >= fifth * 4) {
			// 				$(logo).addClass('ai-panel__logos-logo--double-up');
			// 			}
			// 		});
			// 	} else { // if ( window.matchMedia( '(min-width: 400px)' ).matches ) {
			// 		// Small down (2 col)
			// 		$logos.css('height', totalHeight / 2);

			// 		// Offset second col
			// 		let half = Math.floor($children.length / 2);
			// 		$children.each((index, logo) => {
			// 			if (index >= half) {
			// 				$(logo).addClass('ai-panel__logos-logo--up');
			// 			}
			// 		});
			// 	}
		});

		// Parent measure
		super.measure();

		// Microsite Header Background
		let $firstPanel = $('.microsite__content > .ai-panel:first');
		if ($firstPanel.length) {
			let $bg = $('.microsite-ai__bg');
			let $header = $('.' + this.classes.header);
			let headerHeight = $header.outerHeight(true);
			let firstPanelHeight = $firstPanel.outerHeight(true);
			$bg.height(Math.ceil(headerHeight + firstPanelHeight));
		}

		// // Parallax panels
		// this.parallaxPanels.forEach( ( panel ) => {
		// 	// Stop previous requestAnimationFrames
		// 	if ( panel.requestAnimationFrameId ) cancelAnimationFrame( panel.requestAnimationFrameId );
		// } );
		// this.parallaxPanels = [];
		// $('.ai-panel--parallax').each( ( index, panel ) => {
		// 	let $panel = $( panel );
		// 	let $wrap = $panel.find('.ai-panel__wrap');
		// 	let top = Math.floor( $panel.offset().top );
		// 	let height = Math.floor( $panel.height() );
		// 	let bottom = top + height;

		// 	this.parallaxPanels.push( {
		// 		$: $panel,
		// 		$wrap: $wrap,
		// 		top: top,
		// 		bottom: bottom,
		// 		height: height,
		// 		requestAnimationFrameId: null
		// 	} );
		// } );

		// Image parallax
		if (window.matchMedia('(max-width: 699px)').matches) {
			this.parallaxSpeed = 0.25; // Less on mobile
		} else {
			this.parallaxSpeed = 0.50;
		}
	}

	updateNav(section) {
		// Insert placeholder for nav to prevent scroll position jumps
		if (true !== this.scrolling) {
			if (section && !this.$nav.hasClass(this.classes.navFixed)) {
				let navHeight = this.$nav.outerHeight(true);
				$('<div>').height(navHeight).insertAfter(this.$nav);
			} else if (!section && this.$nav.hasClass(this.classes.navFixed)) {
				this.$nav.next().remove();
			}
		}

		super.updateNav(section);
	}

	updateBack(section) {
		if (true !== this.scrolling) {
			if (section && this.headerShown) {
				// Set back to fixed
				this.$back.addClass(this.classes.backFixed);
			} else {
				// Remove back fixed
				this.$back.removeClass(this.classes.backFixed);
			}
		}
	}

	check() {
		super.check();

		let viewport = this.measureViewport();

		// this.parallaxPanels.forEach( ( panel ) => {
		// 	if ( viewport.bottom > panel.top && viewport.top < panel.bottom ) { // Within view
		// 		// Parallax works better with requestAnimationFrame rather than onScroll
		// 		if ( ! panel.requestAnimationFrameId ) panel.requestAnimationFrameId = requestAnimationFrame( this.parallaxPanel.bind( this, panel ) );
		// 	} else {
		// 		panel.$wrap.css('transform', 'translate3d(0, 0, 0)');
		// 		// Stop requestAnimationFrame();
		// 		if ( panel.requestAnimationFrameId ) cancelAnimationFrame( panel.requestAnimationFrameId );
		// 		panel.requestAnimationFrameId = null;
		// 	}
		// } );

		this.panelLogos.forEach((panelLogo) => {
			if (viewport.bottom > panelLogo.top && viewport.top < panelLogo.bottom) { // Within view
				panelLogo.$.addClass('ai-panel__logos--appear');
			} else {
				panelLogo.$.removeClass('ai-panel__logos--appear');
			}
		});
	}

	replace($currentSection, $newSection) {
		super.replace($currentSection, $newSection);

		// Init flickity sliders
		$newSection.find('.ai-panel__slider').each((index, el) => {
			let attr = el.getAttribute('data-flickity');
			let options = attr && JSON.parse(attr);
			new Flickity(el, options);
		});

		// Init videos
		this.videoInit();

		// Init sector menu
		this.sectorMenuInit();
	}

	parallaxPanel(panel) {
		let viewport = this.measureViewport();

		let viewportMiddle = viewport.top + (viewport.height / 2);
		let panelMiddle = panel.top + (panel.height / 2);
		let offset = (viewportMiddle - panelMiddle) * this.parallaxSpeed;
		// Round offset
		offset = Math.round(offset);
		// Reverse offset
		offset = offset * -1;

		panel.$wrap.css('transform', 'translate3d(0, ' + offset + 'px, 0)');

		// Restart request animation frame
		panel.requestAnimationFrameId = requestAnimationFrame(this.parallaxPanel.bind(this, panel));
	}

	ytAPIInit() {
		var tag = document.createElement('script');
		tag.src = 'https://www.youtube.com/iframe_api';
		var firstScriptTag = document.getElementsByTagName('script')[0];
		firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
	}

	videoInit() {
		$('.ai-media--video:not(.ai-media--video-init)').each((index, video) => {
			let $video = $(video);
			let $container = $video.find('.ai-media__container');
			let $embed = $video.find('.ai-media__embed');
			let $image = $video.find('.ai-media__image');
			let $content = $video.find('.ai-media__content');

			// Mark as initied
			$video.addClass('ai-media--video-init');

			let ready;
			let ytPlayer;

			let inject = () => {
				// Ignore if there is nothing to embed (already embedded)
				if (!$embed.data('embed')) return false;

				log('Inject Video');
				$embed.html($embed.data('embed')); // Inject iframe
				$embed.data('embed', false); // Prevent double-injection
				fitvid();
			};

			let init = () => {
				// Ignore if already init
				if (ready) return false;

				let $iframe = $embed.find('iframe');
				// Ignore if there is no  iframe or it's not a YouTube iframe
				if (!$iframe.length || !$iframe.is('iframe[src*="youtube.com"]')) return false;

				log('Init Video');

				ready = new Promise((resolve, reject) => {
					this.ytAPIReadyPromise.then(() => {
						log('Init YouTube Player');

						let ytLoading = () => {
							log('YouTube Loading');
							$video.trigger('loading');
						};
						let ytPlaying = () => {
							log('YouTube Playing');
							$video.trigger('playing');
						};
						let ytPaused = () => {
							log('YouTube Paused');
							$video.trigger('paused');
						};
						let ytEnded = () => {
							log('YouTube Ended');
							$video.trigger('ended');
						};

						ytPlayer = new YT.Player($iframe[0], {
							events: {
								'onReady': (event) => {
									log('YouTube Player Ready');
									resolve();
								},
								'onStateChange': (event) => {
									/* event.data
									case -1: // Unstarted
									case 0: // Ended
									case 1: // Playing
									case 2: // Paused
									case 3: // Buffering
									case 5: // Video cued
									*/
									// Ignore repeated events
									if (event.data === this.ytPlayerState) {
										return;
									} else if (event.data === 3) { // Loading
										// Set current state
										this.ytPlayerState = event.data;
										ytLoading();
									} else if (event.data === 1) { // Playing
										// Set current state
										this.ytPlayerState = event.data;
										ytPlaying();
									} else if (event.data === 2) { // Paused
										// Set current state
										this.ytPlayerState = event.data;
										ytPaused();
									} else if (event.data === 0) { // Ended
										// Set current state
										this.ytPlayerState = event.data;
										ytEnded();
									}
								},
								'onError': (event) => {
									log('YouTube Player Error!');
									this.triggerEvent('error');
									reject();
								}
							}
						});
					});
				}, () => {
					log('YouTube API not ready!');
					reject();
				});
			};

			let play = () => {
				if (!ready) return false;

				ready.then(() => {
					log('Playing YouTube');
					ytPlayer.playVideo();
				});
			};

			let pause = () => {
				if (!ready) return false;

				// Remove loading
				$video.removeClass('ai-media--video-loading');
				// Remove reveal
				$video.removeClass('ai-media--video-reveal');

				ready.then(() => {
					log('Pausing YouTube');
					ytPlayer.pauseVideo();
				});
			};

			let restart = () => {
				if (!ready) return false;

				ready.then(() => {
					log('Restarting YouTube');
					ytPlayer.seekTo(0);
				});
			}

			if (window.matchMedia('(max-width: 699px)').matches) {
				// Mark as mobile video
				$video.addClass('ai-media--video-mobile');
				// Inject and init video (user will click to play)
				inject();
				init();
			}

			$container.on('click', () => {
				// Inject, init and play video
				inject();
				init();
				restart();
				play();
			}).on('keydown', (e) => {
				if ( 13 == e.which ) { // Enter key
					$container.trigger('click');
				}
			});

			$video.on('loading', () => {
				// Add loading
				$video.addClass('ai-media--video-loading');
			});

			$video.on('playing', () => {
				// Pause all other videos
				$('.ai-media--video').not($video).trigger('pause');

				// Remove loading
				$video.removeClass('ai-media--video-loading');
				// Mark as reveal
				$video.addClass('ai-media--video-reveal');
			});

			$video.on('ended', () => {
				// Restart video
				restart();
				// Pause video
				pause();
			});

			$video.on('pause', () => {
				pause();
			});
		});
	}

	sectorMenuInit() {
		$('.ai-sector-menu:not(.ai-sector-menu--init)').each((index, menu) => {
			let $menu = $(menu);
			$menu.addClass('ai-sector-menu--init');

			$menu.find('.ai-sector-menu__item').on('click', (e) => {
				let selector = e.currentTarget.getAttribute('href');
				let $target = $(selector);
				if ($target.length) {
					this.scrollTo(Math.ceil($target.offset().top), true);
					e.preventDefault();
				}
			});
		});
	}
}

export default MicrositeAi;
